/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BusinessSectorExpertise } from './';
import {
    BusinessSectorExpertiseFromJSON,
    BusinessSectorExpertiseFromJSONTyped,
    BusinessSectorExpertiseToJSON,
} from './';

/**
 * 
 * @export
 * @interface BusinessSectorResponse
 */
export interface BusinessSectorResponse {
    /**
     * 
     * @type {string}
     * @memberof BusinessSectorResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessSectorResponse
     */
    name: string;
    /**
     * 
     * @type {Array<BusinessSectorExpertise>}
     * @memberof BusinessSectorResponse
     */
    expertises: Array<BusinessSectorExpertise>;
}

/**
 * Check if a given object implements the BusinessSectorResponse interface.
 */
export function instanceOfBusinessSectorResponse(value: object): value is BusinessSectorResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('expertises' in value) || value['expertises'] === undefined) return false;
    return true;
}

export function BusinessSectorResponseFromJSON(json: any): BusinessSectorResponse {
    return BusinessSectorResponseFromJSONTyped(json, false);
}

export function BusinessSectorResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessSectorResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'expertises': ((json['expertises'] as Array<any>).map(BusinessSectorExpertiseFromJSON)),
    };
}

export function BusinessSectorResponseToJSON(value?: BusinessSectorResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'expertises': ((value['expertises'] as Array<any>).map((v) => BusinessSectorExpertiseToJSON(v))),
    };
}

